import { PayloadAction } from '@reduxjs/toolkit';
import { ImageHandlingState } from '@reducers/v2/imageHandlingV2/imageHandlingV2.slice';

export const setPreImageHandlingScreenAction = (state: ImageHandlingState, action: PayloadAction<Record<string, unknown> | null>) => {
  state.preImageHandlingScreen = action.payload;
};
